import cookie from 'cookie';
import Cookies from 'universal-cookie';

export function parseCookies(req) {
    return cookie.parse(req ? req.headers.cookie || '' : document.cookie);
}

const cookies = new Cookies();

const cookieName = 'whaUser';

export const getCookie = (name = cookieName) => {
    return cookies.get(name, { path: '/' });
};

export const createCookie = (
    { authenticationResult },
    name = cookieName,
) => {
    cookies.set(
        name,
        {
            access_token: authenticationResult.idToken,
            refreshToken: authenticationResult.refreshToken,
        },
        {
            maxAge: authenticationResult.expiresIn,
            path: '/',
        },
    );
};

export const getKNC = (access_token) => {
    if (access_token) {
        var jwtDecode = require("jwt-decode");
        var decoded = jwtDecode(access_token);
        return decoded.sub;
    }
    return null;
};

export const deleteCookie = (name = cookieName) => {
    cookies.remove(name, { path: '/' });
};